<template>
    <div class="l-main l-container">
        <div class="l-content__block p-index__sale">
            <div class="c-block__headings">
                <h2 class="">重要なお知らせ</h2>
                <div v-if="isMore" class="c-btn-detail"><a :href="route(route_list, 'site.information.important')">もっと見る</a></div>
            </div>
            <div class="">
                <div v-if="info1" class="information l-container">
                    <dl>
                        <dt>{{ info1.date }}</dt>
                        <dd><a :href="info1.url" id="info-001"><span>{{ info1.title }}</span></a></dd>
                    </dl>
                </div>
                <div v-if="info2"  class="information l-container">
                    <dl>
                        <dt>{{ info2.date }}</dt>
                        <dd><a :href="info2.url" id="info-002"><span>{{ info2.title }}</span></a></dd>
                    </dl>
                </div>
                <div v-if="info3"  class="information l-container">
                    <dl>
                        <dt>{{ info3.date }}</dt>
                        <dd><a :href="info3.url" id="info-003"><span>{{ info3.title }}</span></a></dd>
                    </dl>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import routeMixin from '../../mixins/route.js';
export default {
    props:[
        'route_list',
        'importantInformations',
    ],
    mixins: [routeMixin],
    data() {
        return {
            // TOPページに表示するお知らせ(公開日最新1件)
            info1: this.importantInformations[0],
            info2: this.importantInformations[1],
            info3: this.importantInformations[2],
            // 重要なお知らせが3件以上あるか？
            isMore: (this.importantInformations.length > 3) ? true : false,
        }
    }
}
</script>

<style lang="scss" scoped>
.information {
    margin-bottom: 1em;
    &:last-child{
      margin-bottom: 0em;
    }
}
.information dl {
    text-align: left;
    dt {
        color: #9e9e9e;
        font-size: 13px;
    }
    dd {
        font-size: 15px;
        line-height: 1.5;
    }
}
.information dl + dl {
    margin-top: 3em;
}
  
@media (min-width:768px){
    .c-btn-detail {
        a {
            color: #000;
        }
    }
    .l-container {
        justify-content: center;
    }
    .information {
        max-width: 920px;
    }
    .information dl {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        dt {
            width: 120px;
        }
        dd {
            a {
                width: 800px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }
}

@media (max-width:767px) {
    .information dl {
        display: block;
        dt {
            margin-bottom: .5em;
        }
    }
}
</style>
